"use client";

import Link from "next/link";
import { useCreatorTranslations } from "@/i18n/creator/useCreatorTranslations";
import type { CreatorPortalAccess } from "../creatorAuthContext";
import { Card } from "../one/ui";
import { portalHref } from "../useCreatorPortalAccess";
import { RequestRow } from "./RequestRow";
import { useNow } from "./useCreatorRequests";
import type { CreatorFeedItem } from "./utils";

const HOME_ROWS = 2;

/** The portal home's preview of the ranked feed. */
export function OpenRequestsCard({
  items,
  count,
  access,
}: {
  items: CreatorFeedItem[];
  count: number;
  access: CreatorPortalAccess | null;
}) {
  const now = useNow();
  const t = useCreatorTranslations("requests.home");
  return (
    <Card>
      <div className="flex flex-col gap-nf-ds-1 min-w-0 mb-nf-ds-4">
        <div className="flex items-center justify-between gap-nf-ds-3">
          <h3 className="font-nf-ds-sans text-nf-ds-md font-[600] leading-[1.25] tracking-[-0.005em]">
            {t("title")}
          </h3>
          {count > 0 ? (
            <Link
              href={portalHref("/one/requests", access)}
              className="font-nf-ds-sans text-nf-ds-xs text-nf-ds-purple-product hover:text-nf-ds-purple-700"
            >
              {t("seeAll", { count })}
            </Link>
          ) : null}
        </div>
        <p className="font-nf-ds-sans text-[13px] text-muted-foreground">
          {count > 0 ? t("lede") : t("empty")}
        </p>
      </div>
      {items.length > 0 ? (
        <ul className="-mx-nf-ds-3 m-0 flex list-none flex-col gap-nf-ds-1 p-0">
          {items.slice(0, HOME_ROWS).map((item) => (
            <RequestRow key={item.id} item={item} now={now} access={access} />
          ))}
        </ul>
      ) : null}
    </Card>
  );
}
